// Constructor
function GMOs(app) {
	this.app = app;
	this.data = false;
	this.questionId = 0;
	this.timeouts = {};
	this.animating = false;
	this.loadData();
}

GMOs.prototype.loadData = function () {
	$.ajax({
		url: "gmos.html",
		dataType: 'html',
		cache: false,
		complete: $.proxy(function (data, textStatus) {
			$("#game").html(data.responseText);
			// this.app.initSVG();

			$.ajax({
				url: "gmos.json",
				dataType: 'json',
				cache: false,
				complete: $.proxy(function (data) {
					this.data = JSON.parse(data.responseText);
					this.init();
				}, this)
			});

		}, this)
	});

};

GMOs.prototype.init = function () {

	for (var i = 0; i < this.data["questions"].length; i++) {
		var question = this.data["questions"][i];

		// Menu : Clone and remove first element (we use it as template)
		var menuEl = $("#questions-menu ul li").eq(0).clone();
		if (i == 0) {
			$("#questions-menu ul li").eq(0).remove();
		}

		// Menu : Create menu item
		menuEl.removeClass("question-1").addClass("question-" + (i + 1));
		menuEl.attr("data-question", (i + 1));
		menuEl.find(".en").text(question["short_title_en"]);
		menuEl.find(".fr").text(question["short_title_fr"]);
		$("#questions-menu ul").append(menuEl);

		// Answer : Clone and remove first element (we use it as template)
		var answersEl = $("#answers-screen .answers").eq(0).clone();
		if (i == 0) {
			$("#answers-screen .answers").remove();
		}

		// Answer : Create menu item
		answersEl.removeClass("question-1").addClass("question-" + (i + 1));
		answersEl.attr("data-question", (i + 1));

		for (var j = 0; j < question["answers"].length; j++) {
			var answer = question["answers"][j];

			// Clone and remove first element (we use it as template)
			var persoEl = $("li", answersEl).eq(0).clone();
			if (j == 0) {
				$("li", answersEl).remove();
			}

			persoEl.find(".perso").attr("data-type", answer["character"]);
			persoEl.find(".box-title .en").text(answer["title_en"]);
			persoEl.find(".box-title .fr").text(answer["title_fr"]);
			persoEl.find(".box-content .en").html(answer["content_en"]);
			persoEl.find(".box-content .fr").html(answer["content_fr"]);

			persoEl.removeClass("answer-1").addClass("answer-" + (j + 1));
			persoEl.attr("data-answer", (j + 1));

			// menuEl.removeClass("question-1").addClass("question-" + (i + 1));
			// menuEl.attr("data-question", (i + 1));
			// menuEl.find(".en").text(question["short_title_en"]);
			// menuEl.find(".fr").text(question["short_title_fr"]);
			$(answersEl).append(persoEl);
		}

		$("#answers-screen").append(answersEl);

		// #answers-screen
		// console.log(question, menuEl);
	}


	// Go to goto answers screen
	$("#intro-screen ul li").click($.proxy(function (e) {
		var questionId = $(e.currentTarget).data("question");
		this.gotoAnswersScreen(questionId);
	}, this));

	// Go to question
	$("#questions-menu ul li").click($.proxy(function (e) {
		var questionId = $(e.currentTarget).data("question");
		this.gotoQuestion(questionId);
	}, this));

	// Show answer
	$(".perso").click($.proxy(function (e) {
		var answerId = $(e.currentTarget).parents("li").data("answer");
    console.log("click", answerId);
		this.showAnswer(answerId);
	}, this));

	// Close answer
	$(".content-box .box-close").click($.proxy(function (e) {
		var answerId = $(e.currentTarget).parents("li").data("answer");
		this.closeAnswer(answerId);
	}, this));

	// Source
	$("#answers-screen").on('click', ".source", $.proxy(function (e) {
		var answerId = $(e.currentTarget).parents("li").data("answer");
		this.showSource(answerId);
	}, this));

	// Source
	$("#answers-screen, #intro-screen").on('click', ".def", $.proxy(function (e) {
		var defId = $(e.currentTarget).data("def");
		this.showLexique(defId);
	}, this));

	// Init persos and slickify
	this.initPersos();
}


GMOs.prototype.start = function () {

	console.log("Start GMOs : go to intro");

	$("#title-screen").fadeOut("normal", $.proxy(function () {
		$("#title-screen").removeClass("active");
		$("#intro-screen").addClass("active").fadeTo("normal", 1);

	}, this));
};


GMOs.prototype.gotoAnswersScreen = function (questionId) {

	console.log("gotoAnswersScreen");

	$("#intro-screen").fadeOut("normal", $.proxy(function (questionId) {
		$("#intro-screen").removeClass("active");
		$("#answers-screen").addClass("active").fadeTo("normal", 1);

		// Start with question
		this.gotoQuestion(questionId);

		// Show help modal on start
		this.showHelp();

	}, this, questionId));
};


GMOs.prototype.initPersos = function () {

	// Init perso plugin
	$("ul.answers .answer .perso").each(function (i, n) {
		var type = $(n).data("type");
		$(n).perso({
			type: type,
			talk: false
		});
	});

	// Create slider using slick.js
	$("ul.answers").slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1
	});

}

GMOs.prototype.showAnswer = function (answerId) {
	$(".content-box", ".answers.current .answer-" + answerId).removeClass("hide");
	$(".perso", ".answers.current .answer-" + answerId).perso("talk");
}

GMOs.prototype.closeAnswer = function (answerId) {
	$(".content-box", ".answers.current .answer-" + answerId).addClass("hide");
	$(".perso", ".answers.current .answer-" + answerId).perso("shutUp");
}

GMOs.prototype.gotoQuestion = function (questionId) {

	// Validate we are not animating
	if (this.animating) {
		return;
	}
	this.animating = true;

	// Save question id
	this.questionId = questionId;

	// Close
	this.closeQuestion();

	// Fade in
	requestTimeout($.proxy(function (questionId) {
		$(".answers.question-" + questionId).removeClass("hide").addClass("current");

		$(".answers.question-" + questionId).slick("slickGoTo", 0, true);

		$(".answers.current .answer").each(function (i, n) {
			requestTimeout($.proxy(function () {
				$(n).removeClass("hide");
			}, this), 200 * i)
		});

		this.animating = false;

	}, this, questionId), 1000)

	// Update main title
	$("#main-game-title h1.fr .dynamic").html(this.data["questions"][questionId - 1]["title_fr"]);
	$("#main-game-title h1.en .dynamic").html(this.data["questions"][questionId - 1]["title_en"]);

	// Update menu
	$("#questions-menu li").removeClass("active")
	$("#questions-menu li.question-" + questionId).addClass("active")

	// Make sure slick is using full width (issue when hidden)
	// https://github.com/kenwheeler/slick/issues/187
	$("ul.answers").slick("getSlick").refresh();
}


GMOs.prototype.closeQuestion = function () {

	// Close answers
	$(".answers.current .answer").each($.proxy(function (i, n) {
		this.closeAnswer($(n).data("answer"));
	}, this));

	// Fade out
	$(".answers").addClass("hide").removeClass("current");
	$(".answers .answer").addClass("hide");
}


GMOs.prototype.showSource = function (answerId) {

	// Get sources
	var sources = this.data["questions"][this.questionId - 1]["answers"][answerId - 1]["sources"];

	// Empty current elements
	$(".fr, .en", "#source .content").html("");

	$.each(sources, function (i, n) {
		$("#source .content .fr").append("<h3>" + n["title_fr"] + "</h3>" + "<p class='href'>" + n["href_fr"] + "</p>");
		$("#source .content .en").append("<h3>" + n["title_en"] + "</h3>" + "<p class='href'>" + n["href_en"] + "</p>");
	})

	// Make source title singular/plural
	// if (sources.length > 1) {
	// 	$("#source h2").text("Sources");
	// } else {
	// 	$("#source h2").text("Source");
	// }

	this.app.showModal("#source");
}

GMOs.prototype.closeSource = function () {
	this.app.closeModal("#source");
}


GMOs.prototype.showLexique = function (defId) {

	// Get definition
	var definition = this.data["definitions"]["def" + defId];

	// Add title
	$("#lexique h2.fr").html(definition["title_fr"]);
	$("#lexique h2.en").html(definition["title_en"]);

	// Add content
	$("#lexique .content .fr").html(definition["content_fr"]);
	$("#lexique .content .en").html(definition["content_en"]);

	// Show modal
	this.app.showModal("#lexique");
}


GMOs.prototype.closeLexique = function () {
	this.app.closeModal("#lexique");
}


GMOs.prototype.closeHelp = function () {
	this.app.closeModal("#help");
}


GMOs.prototype.showHelp = function () {
	this.app.showModal("#help");
}

GMOs.prototype.reset = function () {

	// Reset is called when returning to screensaver

	// Close help
	this.closeHelp();

	// Close sources
	this.closeSource();

	// Close current question
	this.closeQuestion();

	// Animate in/out and reset classes
	$("#answers-screen, #intro-screen").fadeOut("normal", $.proxy(function () {
		$("#answers-screen").removeClass("active");
		$("#title-screen").addClass("active").fadeTo("normal", 1);
	}, this));

};

// Expose GMOs
window.GMOs = GMOs;
